import React, { useState } from 'react';
import { Radio, Checkbox, Space, Spin } from 'antd';
import ReactMarkdown from 'react-markdown';
import styles from './McqOptions.scss';

const McqOptions = ({ currentMcq, questionDetail, updateAnswer, currentIndex }) => {
  const [savingOption, setSavingOption] = useState(null);

  const handleRadioChange = async (e, value) => {
    // Check if the same option is already selected
    if (questionDetail?.answer && questionDetail.answer[0] === value) {
      return; // Don't show saving or make API call for already selected option
    }

    setSavingOption(value);
    try {
      await updateAnswer(
        currentIndex,
        'radio',
        value,
        () => {
          // Success callback - option is saved
          setSavingOption(null);
        },
        () => {
          // Error callback - save failed
          setSavingOption(null);
        },
      );
    } catch (error) {
      setSavingOption(null);
    }
  };

  const handleCheckboxChange = async (values, option) => {
    if (values.length === 0) return; // Don't save if no options selected

    // Check if the same options are already selected
    const currentAnswer = questionDetail?.answer || [];
    const isSameSelection =
      values.length === currentAnswer.length &&
      values.every(value => currentAnswer.includes(value)) &&
      currentAnswer.every(value => values.includes(value));

    if (isSameSelection) {
      return; // Don't show saving or make API call for already selected options
    }

    // Set saving state for all selected options
    const savingStates = values.reduce((acc, value) => {
      acc[value] = true;
      return acc;
    }, {});
    setSavingOption(savingStates);
    try {
      await updateAnswer(
        currentIndex,
        'checkbox',
        values,
        () => {
          // Success callback - options are saved
          setSavingOption(null);
        },
        () => {
          // Error callback - save failed
          setSavingOption(null);
        },
      );
    } catch (error) {
      setSavingOption(null);
    }
  };

  return (
    <Space
      direction="vertical"
      style={{ display: 'block' }}
    >
      {currentMcq.multipleCorrectAnswers ? (
        <Checkbox.Group
          style={{ display: 'flex', flexDirection: 'column' }}
          value={questionDetail?.answer}
          onChange={handleCheckboxChange}
        >
          {currentMcq.options.map((option, index) => {
            const optionValue = JSON.stringify(option);
            const isSavingThisOption = savingOption && savingOption[optionValue];
            return (
              <div
                key={index}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <Checkbox
                  value={optionValue}
                  className={styles['options']}
                  disabled={savingOption !== null && !isSavingThisOption}
                >
                  <ReactMarkdown>{option.text}</ReactMarkdown>
                </Checkbox>
                {isSavingThisOption && <span className={styles['saving-text']}>Saving...</span>}
              </div>
            );
          })}
        </Checkbox.Group>
      ) : (
        <Radio.Group
          style={{ display: 'flex', flexDirection: 'column' }}
          value={questionDetail?.answer?.[0]}
        >
          {currentMcq.options &&
            currentMcq.options.map((option, index) => (
              <div
                key={index}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <Radio
                  value={JSON.stringify(option)}
                  onClick={e => handleRadioChange(e, JSON.stringify(option))}
                  className={styles['options']}
                  disabled={savingOption !== null}
                >
                  <ReactMarkdown>{option.text}</ReactMarkdown>
                </Radio>
                {savingOption === JSON.stringify(option) && (
                  <span className={styles['saving-text']}>Saving...</span>
                )}
              </div>
            ))}
        </Radio.Group>
      )}
    </Space>
  );
};

export default McqOptions;
